<script setup lang="ts">
import { findClientByTributaryCode } from '@repositories/landing.repository';
import { validationRut } from '../../../../../helpers/validationRUT';
import { ref } from 'vue';
import storePolicy from '@store/policy';
import { validationCUIT } from '../../../../../helpers/validationCUIT';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const props = defineProps<{
  companySelectedByParams: any;
  inputsHidden: boolean;
}>();
const emit = defineEmits(['submitCUIT']);
const store = storePolicy();

const fieldsForm1: any = ref([
  {
    key: 'cuit',
    title: t('landing.forms.form_cuit_ar.cuit_del_cliente'),
    type: 'number',
    validations: {
      rules: {
        required: true,
      },
    },
    placeholder: t('landing.forms.form_cuit_ar.cuit_del_cliente_sin_guiones'),
    value: null,
    cols: 12,
    customClass: 'inputLanding text-uppercase',
    hidden: false,
    formatValue: (e: string) => e?.replace(/[^0-9]/g, '') ?? '',
    errors: [],
  },
]);

const handleOnSubmitCUIT = async (e: any) => {
  const checkCuil = validationCUIT(e.items.cuit);

  if (
    !e.isFormValid ||
    !checkCuil.valid ||
    checkCuil.type === 'Tipo desconocido'
  ) {
    return (fieldsForm1.value[0].errors = ['CUIT es invalido']);
  }

  const { client } = await findClientByTributaryCode(e.items.cuit);

  if (client) {
    store.setProp({ key: 'client', value: client });
  }

  if (client) {
    const updatesClientInputs = [
      { key: 'tradeName', value: client.tradeName },
      { key: 'phone1', value: client.phone1 },
      {
        key: 'companyGPSId',
        value: {
          id: props.companySelectedByParams?.value?.id ?? client.companyGPS.id,
          nombre:
            props.companySelectedByParams?.value?.nombre ??
            client.companyGPS.description,
        },
      },
      { key: 'address', value: client.address },
      { key: 'province', value: { nombre: client.regionProvince } },
      { key: 'city', value: { nombre: client.location } },
      { key: 'postCode', value: client.postCode },
    ];

    fieldsForm1.value.find((field: any) => field.key === 'cuit').disabled =
      true;
    // fieldsForm2.value.find((field: any) => field.key === 'tradeName').validations.rules.max = checkCuil.type === 'Persona Jurídica' ? 40 : 20;
    return emit('submitCUIT', {
      cuit: e.items.cuit,
      updatesClientInputs,
      client,
    });
  }
  fieldsForm1.value.find((field: any) => field.key === 'cuit').disabled = true;
  emit('submitCUIT', { cuit: e.items.cuit });
};
</script>

<template>
  <Form ref="refTableForm" :inputs="fieldsForm1" @onSubmit="handleOnSubmitCUIT">
    <template #buttons>
      <div class="d-flex" v-if="inputsHidden">
        <CButton
          class="p-4 w-100 my-2 px-2"
          background="background-green"
          style="font-size: 1rem"
        >
          <template #content>{{ t('landing.forms.form_cuit_ar.comprobar_cuit') }}</template>
        </CButton>
      </div>
    </template>
  </Form>
</template>
